import React, { FC, useState } from 'react';
import styled from 'styled-components';
import { centered } from '@/components/use-shared-element';
import { QueryBuilder } from '@/components/query-builder';
import { QBItemSelection } from '@/components/query-builder/models';
import { useConditionalQueryBuilder } from '@/features/editor/widgets/custom-widget/loading-section/conditional-product/useConditionalQueryBuilder';
import { RecommendationType } from '@/webapi/use-widget-catalog-api';
import { GradientModal } from '@/components/gradient-modal';
import { Footer } from '@/features/editor/widgets/shared/modals/commons';

interface ConditionalProductsPicker {
  fromRef: any;
  isVisible: boolean;
  setIsVisible: (value: boolean) => void;
  initialState?: QBItemSelection[];
  strategy: RecommendationType;
  updateRecommendationCondition: (options: Array<QBItemSelection>) => void;
}

export const AdvancedEditing: FC<ConditionalProductsPicker> = ({
  fromRef,
  isVisible,
  setIsVisible,
  initialState,
  strategy,
  updateRecommendationCondition,
}: ConditionalProductsPicker) => {
  const [currentCondition, setCurrentCondition] = useState<QBItemSelection[]>(
    [],
  );

  const onQueryBuilderChange = (value: QBItemSelection[]) => {
    setCurrentCondition(value);
  };

  const { condition } = useConditionalQueryBuilder(strategy);

  const onSave = () => {
    updateRecommendationCondition(currentCondition);
    setIsVisible(false);
  };

  return (
    <GradientModal
      aspectRatio={1.9}
      headerTop={0.8}
      closeTop="0.5rem"
      closeRight="2.5rem"
      fromStyle={{
        opacity: 0,
        borderRadius: `5rem`,
        backgroundColor: `#DEDEDE`,
        padding: `2rem 0 0 0`,
      }}
      toStyle={{
        background: `white`,
        opacity: 1,
        borderRadius: `1rem`,
        backgroundColor: `#FFFFFF`,
        padding: `2rem 0 0 0`,
      }}
      isVisible={isVisible}
      showBackdrop
      targetPosAndSize={centered(94, 115)}
      fromRef={fromRef}
      overflowTop={{ heightInRem: 8 }}
      overflowBottom={{ heightInRem: 8, turnPointInPercent: 30 }}
      onClose={() => setIsVisible(false)}
      header={<Header>More Filters</Header>}
      footer={<Footer bg="black" size="xl" text="Save" onClick={onSave} />}
    >
      <Container>
        <QueryBuilder
          onChange={onQueryBuilderChange}
          initialProps={condition}
          initialState={initialState}
        />
      </Container>
    </GradientModal>
  );
};

const Header = styled.div`
  position: relative;
  width: 100%;
  border-bottom: 3px #f5f5f5 solid;
  margin: 0 4rem;
  padding-bottom: 2rem;
`;

const Container = styled.div`
  min-width: 80rem;
  width: 100%;
  padding: 2rem 4rem 4rem;
`;
